import { ImageWraper } from '@components/shared/wraper/ImageWraper'
import { Lecturer } from '@type/buzzkuri/programs-categor'
import React from 'react'
import Link from 'next/link'
import { cloudfrontPath } from '@utils/image'

type Props = {
  lecturer: Lecturer
}

export const CategoryLecturersContentItem = ({
  lecturer,
}: Props): JSX.Element => {
  const { id, imagePath, name } = lecturer
  return (
    <Link href={`/lecturers/${id}`}>
      <a>
        <div className="flex flex-col bg-gradient-to-b from-primaryTo to-primaryFrom rounded-[20px] shadow-button lg:hover:opacity-50">
          <div className="w-[74.9vw] lg:w-[17.2vw]">
            <ImageWraper
              className="rounded-t-[20px]"
              src={imagePath}
              width={229}
              height={231}
            />
          </div>
          <div className="flex flex-row justify-between items-center lg:mx-[1.6vw] mr-[8vw] ml-[12vw] h-[16.3vw] lg:h-[5.4vw]">
            <div className="text-[4vw] lg:text-[1vw] font-bold lg:tracking-[0.1vw] text-white">
              {name}
            </div>
            <div>
              <div className="w-[4vw] lg:w-[1vw]">
                <ImageWraper
                  src={`${cloudfrontPath}/programs/icons/top/right_arrow_bold.svg`}
                  width={20}
                  height={20}
                />
              </div>
            </div>
          </div>
        </div>
      </a>
    </Link>
  )
}
